import alertVariables from './alertVariables';

export default alertVariables;
